import { render, staticRenderFns } from "./PsConfigurationWaysToPay.vue?vue&type=template&id=6f695a92&scoped=true&"
import script from "./PsConfigurationWaysToPay.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationWaysToPay.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationWaysToPay.vue?vue&type=style&index=0&id=6f695a92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f695a92",
  null
  
)

export default component.exports